import { ReactNode } from 'react';

import { MenuItem, Typography, useTheme } from '@mui/material';

export interface TabMenuListItemProps {
    isActive: boolean;
    label: ReactNode;
    onClick: () => void;
}

const COLOR_INACTIVE = '#686867';

export default function TabMenuListItem({ isActive, label, onClick }: Readonly<TabMenuListItemProps>) {
    const theme = useTheme();

    return (
        <MenuItem
            key={1}
            selected={false}
            onClick={onClick}
            sx={{
                display: 'flex',
                width: '100%',
                objectFit: 'contain',
                padding: '0',
            }}
        >
            <Typography
                fontSize={isActive ? '16px' : '14px'}
                sx={{
                    color: isActive ? 'white' : COLOR_INACTIVE,
                    fontWeight: isActive ? 500 : 400,
                    bgcolor: (() => {
                        if (isActive) {
                            return theme.palette.orange.main;
                        }
                        return 'transparent';
                    })(),
                }}
                padding="24px"
                width="100%"
                textAlign="center"
            >
                {label}
            </Typography>
        </MenuItem>
    );
}
